export interface PostboxPolicy {
  line: string
  kundenVSNr: string
  readStatus: 'read' | 'unread'
  checked: boolean
}

export enum PostboxStatus {
  UNREAD = 'unread',
  READ = 'read',
  ALL = 'all'
}

export const postboxStatusLabels = {
  [PostboxStatus.UNREAD]: 'Ungelesen',
  [PostboxStatus.READ]: 'Gelesen',
  [PostboxStatus.ALL]: 'Alle Nachrichten'
}

export enum PostboxZeitraum {
  LAST_30_D = 'Die letzten 30 Tage',
  LAST_90_D = 'Die letzten 3 Monate',
  LAST_6_M = 'Die letzten 6 Monate',
  ALL = 'Alle Nachrichten'
}

export const postboxZeitraumShortLabels = {
  [PostboxZeitraum.LAST_30_D]: '30 Tage',
  [PostboxZeitraum.LAST_90_D]: '3 Monate',
  [PostboxZeitraum.LAST_6_M]: '6 Monate',
  [PostboxZeitraum.ALL]: 'Gesamter Zeitraum'
}
